import { Button } from '@/components';
import { Badge } from '@/components/ui/badge';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import { BerufeFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/components/Filter/BerufeFilter';
import { LehrjahrFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/components/Filter/LehrjahrFilter';
import { StatusFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/components/Filter/StatusFilter';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export function Header() {
  const [showUebersichtFilterOptions, setShowUebersichtFilterOptions] =
    useState(false);
  const { store } = useRotationsplanFeatureContext();
  const { view } = useParams();
  const { t } = useTranslation();

  const {
    ui: {
      uebersicht: { filter },
    },
  } = store;

  let selectedFilterCount = 0;
  Object.values(filter).forEach((filter) => {
    if (filter.length > 0) {
      selectedFilterCount += 1;
    }
  });

  return (
    <>
      <Button
        className="flex gap-1 items-center"
        variant="ghost"
        onClick={() => setShowUebersichtFilterOptions((prev) => !prev)}>
        <FontAwesomeIcon icon={faFilter} />
        {t('domain.mitarbeiter.rotationsplan.filter.label')}
        <Badge type="pill" variant="secondary">
          {selectedFilterCount}
        </Badge>
      </Button>
      {showUebersichtFilterOptions && (
        <div className="w-full overflow-auto">
          <div className="flex items-center gap-2">
            <BerufeFilter view={view as View} />
            <LehrjahrFilter view={view as View} />
            <StatusFilter />
          </div>
        </div>
      )}
    </>
  );
}
